const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

export default deepClone;
